import api from "../../../api/api";

const saveDocumentNote = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/document/data/note",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const documentDataServices = {
   saveDocumentNote
}
export default documentDataServices;